/**
 * ColumnTaskRow — `column.task` renderer. Paints the source's tasks in the
 * `column` slot. Hydrated as a `tasks` source's default renderer (shape
 * `task/v1`) and declared explicitly by the `alias.task-list` template;
 * the DOM plugin (`COLUMN_TASK_SPEC`) reads tasks via `tasksDataProvider`.
 */

import { RendererRow } from "./renderer-row.ts";

export class ColumnTaskRow extends RendererRow {}
